// import * as THREE from "three";
import { computeBoundsTree, MeshBVH, MeshBVHVisualizer } from "three-mesh-bvh";
import { drawBox, drawPoint } from "../draw/draw";
// import { runSmoothing } from "../dicom/smoothing";
import { enterAirwayMode } from "./AirwayMode";
import worker from "workerize-loader!./AirwaySmoothing";
// import { vec3 } from "../../../public/js/gl-matrix";

//#region Fields
const params = {
  useBVH: true,
  helperDepth: 5,
};

const tempVector = new THREE.Vector3();
const tempLine = new THREE.Line3();
const localPlane = new THREE.Plane();
const clippingPlane = new THREE.Plane();

// let isAirwayColored = false;
let airwayColors = null;

//#endregion

function airwaySetColor() {
  try {
    // if (!isAirwayColored) {
    // isAirwayColored = true;
    if (!vueApp.airways || !vueApp.airways.length) return;
    let airway = vueApp.airways[0];
    let airwayMesh = viewer.get_model_mesh(airway.id);
    // airwayMesh.visible = false;
    setTimeout(function () {
      let geometry = airwayMesh.geometry;
      if (!geometry.boundingBox) {
        geometry.computeBoundingBox();
      }

      let airwayBox = geometry.boundingBox
        .clone()
        .applyMatrix4(airwayMesh.matrix);
      airwayBox = offsetBox(airwayBox);
      airway.boundingBox = airwayBox;
      let airwaySquare = airwayBox.size.x * airwayBox.size.z;
      console.log("airwaySetColor", new Date(), airwaySquare, airwayBox);
      // drawBox(airwayBox);
      // drawSlices(airwayBox);
      let totalCount = vueApp.allItems.length;

      if (airwaySquare > 2000) {
        const airwayMaxColor = "#0000ff";
        airway.colors = airwayColors = [
          {
            stop: 0,
            color: airwayMaxColor,
            area: airwaySquare,
          },
        ];
        airwayMesh.material.color = new THREE.Color(airwayMaxColor);
        airway.color = vueApp.airwaysColor = airwayMaxColor;
        // airwayMesh.visible = airway.isVisible;
      } else {
        let bufferGeometry = null;
        if (geometry._bufferGeometry) bufferGeometry = geometry._bufferGeometry;
        else if (airwayMesh.geometry.type == "BufferGeometry") {
          bufferGeometry = airwayMesh.geometry;
        } else {
          bufferGeometry = new THREE.BufferGeometry().fromGeometry(
            airwayMesh.geometry,
          );
        }
        console.time("airwayColors");
        console.time("mergeVertices");
        bufferGeometry =
          THREE.BufferGeometryUtils.mergeVertices(bufferGeometry);
        console.timeEnd("mergeVertices");

        airwayMesh.geometry = bufferGeometry;

        if (!airwayColors)
          airwayColors = getColorsForAirway(airwayMesh, airwayBox);
        airway.colors = airwayColors;
        const threeColors = airwayColors.map((c) => {
          const cobj = { stop: c.stop, color: new THREE.Color(c.color) };
          cobj.y =
            airwayBox.min.y + c.stop * airwayBox.size.y - airwayBox.center.y;
          return cobj;
        });
        console.timeEnd("airwayColors");
        console.log("threeColors", threeColors);
        // airwayMesh.baseMaterial = airwayMesh.material.clone();

        console.time("updateToGradient");
        updateToGradient(airwayMesh, threeColors);
        // airwayMesh.visible = airway.isVisible;
        // airwayMesh.gradientMaterial = airwayMesh.material;
        console.timeEnd("updateToGradient");

        console.log("smoothing airways");
        let positionAttr = bufferGeometry.getAttribute("position");
        let indexAttr = bufferGeometry.index;
        let oldVertices = positionAttr ? positionAttr.array : [];
        let oldIndices = indexAttr ? indexAttr.array : [];
        if (oldVertices.length > 0 && oldIndices.length > 0) {
          let instance = worker();
          instance
            .runSmoothingForVertices(oldVertices, oldIndices, 10)
            .then((newVertices) => {
              console.log(`newVertices length ${newVertices.length}`);
              const vertices = new Float32Array(newVertices);
              let smoothedGeometry = new THREE.BufferGeometry();
              smoothedGeometry.setAttribute(
                "position",
                new THREE.BufferAttribute(vertices, 3),
              );
              smoothedGeometry.setIndex(bufferGeometry.index);

              smoothedGeometry.computeVertexNormals();
              smoothedGeometry.computeBoundingBox();
              airwayMesh.baseGeometry = airwayMesh.geometry;
              airwayMesh.geometry = airwayMesh.smoothedGeometry =
                smoothedGeometry;
              updateToGradient(airwayMesh, threeColors);
              // airwayMesh.visible = airway.isVisible;

              airway.isSmoothed = true;
              if (totalCount == 1 && vueApp.airways.length == 1) {
                enterAirwayMode();
              }
            });
        }
      }

      // mesh.geometry = runSmoothing(new THREE.BufferGeometry().fromGeometry(mesh.geometry), 10);
      // viewer.set_opacity(airway.id, 0.6);
      if (totalCount == 1 && vueApp.airways.length == 1) {
        $(".menu3d").css({ display: "none" });
        $("#airwayExitBtn").css({ display: "none" });
      }
      //  else {
      //   airwayMesh.visible = true;
      // }
    }, 300);
    // }
  } catch (error) {
    console.error("airwaySetColor ERROR", error);
  }
}

function getColorsForAirway(mesh, airwayBox) {
  const dy = 0.6;
  const min = airwayBox.min.y + dy;
  const height = airwayBox.size.y - dy * 2;
  const colors = [];

  clippingPlane.normal.set(0, -1, 0);
  for (let i = 0; i <= 10; i++) {
    clippingPlane.constant = min + (height * i) / 10;

    let area = 0;
    let figures = getFiguresForPlane(mesh, mesh.geometry, clippingPlane);
    figures.forEach((figure, index) => {
      let figureArea = Math.abs(THREE.ShapeUtils.area(figure.vertices));
      area += figureArea;
    });
    // console.log("area " + i, area);

    const color = getColorFromArea(area);
    colors.push({
      stop: i / 10,
      color: color,
      area: area,
    });
  }
  console.log("airway colors", colors);
  return colors;
}

function getFiguresForPlane(mesh, geometry, clippingPlane) {
  let segments = getMeshSegmentsForPlane(mesh, geometry, clippingPlane);
  let verticesArr = [];
  while (segments.length > 0) {
    let vertices = getVerticesFromSegments(segments);
    if (vertices.length) {
      verticesArr.push(vertices);
    }
  }

  let figures = getFiguresFromVertices(verticesArr);
  return figures;
}

function getColorFromArea(area) {
  if (area > 400) {
    return "#0000ff";
  } else if (area > 350) {
    return "#0080ff";
  } else if (area > 300) {
    return "#00bfff";
  } else if (area > 250) {
    return "#00ffff";
  } else if (area > 200) {
    return "#00ffbf";
  } else if (area > 150) {
    return "#00ff80";
  } else if (area > 100) {
    return "#00ff00";
  } else if (area > 75) {
    return "#ffff00";
  } else if (area > 55) {
    return "#ff8000";
  } else {
    return "#ff0000";
  }
  // if (area < 100) {
  //   return "#FF0000";
  // } else if (area < 130) {
  //   return "#F1C232";
  // } else if (area < 200) {
  //   return "#FAFF00";
  // } else if (area < 300) {
  //   return "#00FF16";
  // } else if (area < 350) {
  //   return "#00C6FF";
  // } else {
  //   return "#000FFF";
  // }
}

function updateToGradient(mesh, colors) {
  let geometry = mesh.geometry;
  let bufferGeometry = null;
  if (geometry._bufferGeometry) bufferGeometry = geometry._bufferGeometry;
  else if (mesh.geometry.type == "BufferGeometry") {
    bufferGeometry = mesh.geometry;
  } else {
    bufferGeometry = new THREE.BufferGeometry().fromGeometry(mesh.geometry);
  }
  // if (bufferGeometry) {
  //   geometry = new THREE.Geometry();
  //   geometry.fromBufferGeometry(bufferGeometry);

  //   mesh.geometry.dispose();
  //   mesh.geometry = geometry;
  // }

  setGradientBuffer(geometry, colors, mesh.material.color);
  // setGradient(geometry, colors, "y", false);
  // geometry.computeVertexNormals();

  var phongMaterial = new THREE.MeshPhongMaterial({
    // color: "#ffffff",
    vertexColors: THREE.VertexColors,
    flatShading: false,
    specular: 0x050505,
    shininess: 100,
    transparent: true,
    side: THREE.DoubleSide,
  });

  mesh.material = phongMaterial;
  mesh.receiveShadow = false;
  mesh.castShadow = false;
}

function setGradientBuffer(geometry, colors, defColor) {
  const colorsArr = [];
  // const colorTop = new THREE.Color(0xff0000); // Red
  // const colorBottom = new THREE.Color(0x0000ff); // Blue

  for (let i = 0; i < geometry.attributes.position.count; i++) {
    const y = geometry.attributes.position.getY(i);
    let interpolatedColor = defColor; //.clone();
    let found = false;
    for (let c = 1; c < colors.length; c++) {
      if (y <= colors[c].y) {
        const colorObj1 = colors[c - 1];
        const colorObj2 = colors[c];
        const dy = (colorObj2.y - y) / (colorObj2.y - colorObj1.y);
        interpolatedColor = colorObj2.color.clone().lerp(colorObj1.color, dy);
        found = true;
        break;
      }
    }

    // if (!found) {
    //   console.log("!found");
    // }

    // Interpolate color based on y-coordinate
    // const interpolatedColor = new THREE.Color()
    //   .copy(colorBottom)
    //   .lerp(colorTop, (y + 15) / 30); // Assuming y from -0.5 to 0.5
    colorsArr.push(
      interpolatedColor.r,
      interpolatedColor.g,
      interpolatedColor.b,
    );
  }
  let colorAttr = new THREE.Float32BufferAttribute(colorsArr, 3);
  geometry.setAttribute("color", colorAttr);
  // geometry.setAttribute("gradientColor", colorAttr);
}

function setGradient(geometry, colors, axis, reverse) {
  geometry.computeBoundingBox();

  var bbox = geometry.boundingBox;
  var size = new THREE.Vector3().subVectors(bbox.max, bbox.min);

  var vertexIndices = ["a", "b", "c"];
  var face,
    vertex,
    normalized = new THREE.Vector3(),
    normalizedAxis = 0;

  for (var c = 0; c < colors.length - 1; c++) {
    var colorDiff = colors[c + 1].stop - colors[c].stop;

    for (var i = 0; i < geometry.faces.length; i++) {
      face = geometry.faces[i];
      for (var v = 0; v < 3; v++) {
        vertex = geometry.vertices[face[vertexIndices[v]]];
        normalizedAxis = normalized.subVectors(vertex, bbox.min).divide(size)[
          axis
        ];
        if (reverse) {
          normalizedAxis = 1 - normalizedAxis;
        }
        if (
          normalizedAxis >= colors[c].stop &&
          normalizedAxis <= colors[c + 1].stop
        ) {
          var localNormalizedAxis =
            (normalizedAxis - colors[c].stop) / colorDiff;
          face.vertexColors[v] = colors[c].color
            .clone()
            .lerp(colors[c + 1].color, localNormalizedAxis);
        }
      }
    }
  }
}

function getMeshSegmentsForPlane(mesh, geometry, clippingPlane) {
  if (!geometry.colliderBvh || !geometry.inverseMatrix) {
    let bufferGeometry = null;
    if (geometry._bufferGeometry) bufferGeometry = geometry._bufferGeometry;
    else if (geometry.type == "BufferGeometry") {
      bufferGeometry = geometry;
    } else {
      bufferGeometry = new THREE.BufferGeometry().fromGeometry(geometry);
    }
    const clonedGeometry = bufferGeometry.clone();
    clonedGeometry.applyMatrix4(mesh.matrixWorld);
    for (const key in clonedGeometry.attributes) {
      if (key === "position" || key === "normal") {
        continue;
      }
      clonedGeometry.deleteAttribute(key);
    }

    const colliderBvh = (geometry.colliderBvh = new MeshBVH(clonedGeometry, {
      maxLeaafTris: 20, // 10
      maxDepth: 30, // 40 //5
    }));
    bufferGeometry.boundsTree = colliderBvh;
    const colliderMesh = new THREE.Mesh(bufferGeometry);
    colliderMesh.renderOrder = 2;
    const inverseMatrix = new THREE.Matrix4();
    inverseMatrix.copy(colliderMesh.matrixWorld).invert();
    geometry.inverseMatrix = inverseMatrix;
  }
  let segments = renderBVH(
    geometry.colliderBvh,
    geometry.inverseMatrix,
    clippingPlane,
  );
  return segments;
}

function renderBVH(colliderBvh, inverseMatrix, clippingPlane, appIndex) {
  let segments = [];
  if (colliderBvh) {
    // const startTime = window.performance.now();
    localPlane.copy(clippingPlane).applyMatrix4(inverseMatrix);
    let i = 0;
    colliderBvh.shapecast({
      intersectsBounds: (box) => {
        //return CONTAINED;
        return localPlane.intersectsBox(box);
      },
      intersectsTriangle: (tri) => {
        // i++;
        // let color = 0xff0000;
        // if (i % 2 == 0) color = 0x00ff00;
        // if (i % 3 == 0) color = 0x0000ff;
        // drawLine(tri.a, tri.b, color);
        // drawLine(tri.b, tri.c, color);
        // drawLine(tri.c, tri.a, color);
        const points = [];
        tempLine.start.copy(tri.a);
        tempLine.end.copy(tri.b);
        if (localPlane.intersectLine(tempLine, tempVector)) {
          points.push(convertTo2dPoint(tempVector));
        }

        tempLine.start.copy(tri.b);
        tempLine.end.copy(tri.c);
        if (localPlane.intersectLine(tempLine, tempVector)) {
          points.push(convertTo2dPoint(tempVector));
        }

        tempLine.start.copy(tri.c);
        tempLine.end.copy(tri.a);
        if (localPlane.intersectLine(tempLine, tempVector)) {
          points.push(convertTo2dPoint(tempVector));
        }

        if (points.length === 2) {
          let segment = {
            p1: points[0],
            p2: points[1],
          };
          segments.push(segment);
          //   drawLine(points[0].vector, points[1].vector, color);
          //   drawPoint(vectors[0], color, false, 0.05);
          //   drawPoint(vectors[1], color, false, 0.05);
        }
      },
    });
    // const delta = window.performance.now() - startTime;
    // console.log(`slice time: ${parseFloat(delta.toFixed(3))}ms`);
  }
  return segments;
}

function getVerticesFromSegments(segments) {
  // console.log(segments);
  let vertices = [];
  let head = segments.length ? segments[0] : null;
  let tail = head;
  let headIndex = 0;
  let tailIndex = headIndex;
  while (head || tail) {
    if (head && headIndex >= 0) {
      vertices.unshift(head.p1);
      segments.splice(headIndex, 1);
    }
    if (tail && tailIndex >= 0) {
      vertices.push(tail.p2);
      if (head != tail) {
        segments.splice(
          !head || headIndex > tailIndex ? tailIndex : tailIndex - 1,
          1,
        );
      }
    }

    if (head) {
      headIndex = findHeadIndex(segments, head);
      head = headIndex >= 0 ? segments[headIndex] : null;
    }
    if (tail) {
      tailIndex = findTailIndex(segments, tail);
      tail = tailIndex >= 0 ? segments[tailIndex] : null;
    }
  }
  // console.log("segments.length", segments.length);
  return vertices;
}

function getFiguresFromVertices(verticesArr) {
  let figures = [];
  if (verticesArr && verticesArr.length) {
    verticesArr = verticesArr.sort((a, b) => b.length - a.length);
    let figure = null;
    verticesArr.forEach((vertices, index) => {
      figure = { vertices: vertices };
      figures.push(figure);
    });
  }
  return figures;
}

function convertTo2dPoint(vector) {
  let point = new THREE.Vector2(+vector.x.toFixed(3), +vector.z.toFixed(3));
  //   if (vector.clone) point.vector = vector.clone();
  return point;
}

function findHeadIndex(segments, head) {
  let headIndex = segments.findIndex(
    (segment) => segment.p2.x == head.p1.x && segment.p2.y == head.p1.y,
  );
  if (headIndex < 0) {
    headIndex = segments.findIndex(
      (segment) => segment.p1.x == head.p1.x && segment.p1.y == head.p1.y,
    );
    let nhead = headIndex >= 0 ? segments[headIndex] : null;
    if (nhead) {
      let temp = nhead.p1;
      nhead.p1 = nhead.p2;
      nhead.p2 = temp;
    }
  }
  return headIndex;
}

function findTailIndex(segments, tail) {
  let tailIndex = segments.findIndex(
    (segment) => segment.p1.x == tail.p2.x && segment.p1.y == tail.p2.y,
  );
  if (tailIndex < 0) {
    tailIndex = segments.findIndex(
      (segment) => segment.p2.x == tail.p2.x && segment.p2.y == tail.p2.y,
    );
    let ntail = tailIndex >= 0 ? segments[tailIndex] : null;
    if (ntail) {
      let temp = ntail.p1;
      ntail.p1 = ntail.p2;
      ntail.p2 = temp;
    }
  }
  return tailIndex;
}

function drawSlices(airwayBox) {
  const size = Math.max(airwayBox.size.x, airwayBox.size.z);
  const planeGeom = new THREE.PlaneGeometry(size, size);
  const planeMat = new THREE.MeshBasicMaterial({
    color: 0xff0000,
    side: THREE.DoubleSide,
    transparent: true,
    opacity: 0.5,
    depthWrite: false,
  });

  const plane1 = new THREE.Mesh(planeGeom, planeMat);
  plane1.rotation.set(Math.PI / 2, 0, 0);
  plane1.position.set(airwayBox.center.x, airwayBox.min.y, airwayBox.center.z);
  viewer.scene.add(plane1);
  for (let i = 1; i < 10; i++) {
    const plane2 = plane1.clone();
    plane2.position.set(
      airwayBox.center.x,
      airwayBox.min.y + (airwayBox.size.y * i) / 9,
      airwayBox.center.z,
    );
    viewer.scene.add(plane2);
  }
}

function updateToGradient1(mesh) {
  console.log("updateToGradient1");
  var geometry = mesh.geometry;
  geometry.computeBoundingBox();
  var material = new THREE.ShaderMaterial({
    uniforms: {
      color1: {
        value: new THREE.Color("red"),
      },
      color2: {
        value: new THREE.Color("purple"),
      },
    },
    vertexShader: `
          varying vec2 vUv;
      
          void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
          }
        `,
    fragmentShader: `
          uniform vec3 color1;
          uniform vec3 color2;
        
          varying vec2 vUv;
          
          void main() {
            
            gl_FragColor = vec4(mix(color1, color2, vUv.y), 1.0);
          }
        `,
    wireframe: true,
  });
  mesh.material = material;
}

function updateToGradient2(mesh) {
  console.log("updateToGradient2");
  var geometry = mesh.geometry;
  // geometry.applyMatrix4(mesh.matrix);
  geometry.computeBoundingBox();
  var material = new THREE.ShaderMaterial({
    uniforms: {
      color1: {
        value: new THREE.Color("red"),
      },
      color2: {
        value: new THREE.Color("purple"),
      },
      bboxMin: {
        value: geometry.boundingBox.min,
      },
      bboxMax: {
        value: geometry.boundingBox.max,
      },
    },
    vertexShader: `
          uniform vec3 bboxMin;
          uniform vec3 bboxMax;
        
          varying vec2 vUv;
      
          void main() {
            vUv.y = (position.y - bboxMin.y) / (bboxMax.y - bboxMin.y);
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
          }
        `,
    fragmentShader: `
          uniform vec3 color1;
          uniform vec3 color2;
        
          varying vec2 vUv;
          
          void main() {
            
            gl_FragColor = vec4(mix(color1, color2, vUv.y), 1.0);
          }
        `,
    // wireframe: true,
  });
  mesh.material = material;
}

function hslToHex(h, s, l) {
  if (!s) {
    s = 100;
  }
  if (!l) {
    l = 50;
  }

  l /= 100;
  const a = (s * Math.min(l, 1 - l)) / 100;
  const f = (n) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, "0"); // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

export { airwaySetColor, hslToHex, getFiguresForPlane };
